<template>
  <div class="no-small">
    <img src="./../assets/illustrations/Music.png" />
    <img src="./../assets/illustrations/QLD.png" />
    <img src="./../assets/illustrations/Heart.png" />
    <img src="./../assets/illustrations/Smile.png" />
    <img src="./../assets/illustrations/Ladder.png" />
    <img src="./../assets/illustrations/Leaf.png" />
    <img src="./../assets/illustrations/Floatie.png" />
    <img src="./../assets/illustrations/Forest.png" />
    <img src="./../assets/illustrations/Trolley.png" />
    <img src="./../assets/illustrations/Unicorn.png" />
    <img src="./../assets/illustrations/BarbieArm.png" />
    <img src="./../assets/illustrations/Box.png" />
    <img src="./../assets/illustrations/Cabin.png" />
    <img src="./../assets/illustrations/Campfire.png" />
    <img src="./../assets/illustrations/Flamingo.png" />
    <img src="./../assets/illustrations/Forest.png" />
    <img src="./../assets/illustrations/Box.png" />
    <img src="./../assets/illustrations/Cabin.png" />
    <img src="./../assets/illustrations/Campfire.png" />
    <img src="./../assets/illustrations/Flamingo.png" />
    <img src="./../assets/illustrations/Ladder.png" />
    <img src="./../assets/illustrations/Forest.png" />
    <img src="./../assets/illustrations/Heart.png" />
    <img src="./../assets/illustrations/Leaf.png" />
    <img src="./../assets/illustrations/Floatie.png" />
    <img src="./../assets/illustrations/Forest.png" />
    <img src="./../assets/illustrations/Trolley.png" />
    <img src="./../assets/illustrations/Heart.png" />
    <img src="./../assets/illustrations/Unicorn.png" />
    <img src="./../assets/illustrations/Ladder.png" />
    <img src="./../assets/illustrations/Heart.png" />
    <img src="./../assets/illustrations/Leaf.png" />
    <img src="./../assets/illustrations/Floatie.png" />
    <img src="./../assets/illustrations/Ladder.png" />
    <img src="./../assets/illustrations/Leaf.png" />
    <img src="./../assets/illustrations/Lightning.png" />
    <img src="./../assets/illustrations/Moon.png" />
    <img src="./../assets/illustrations/Mountain.png" />
    <img src="./../assets/illustrations/Mushroom.png" />
    <img src="./../assets/illustrations/Star.png" />
    <img src="./../assets/illustrations/Sunglasses.png" />
    <img src="./../assets/illustrations/Triangle.png" />
    <img src="./../assets/illustrations/BarbieArm.png" />
    <img src="./../assets/illustrations/Box.png" />
    <img src="./../assets/illustrations/Cabin.png" />
    <img src="./../assets/illustrations/Campfire.png" />
    <img src="./../assets/illustrations/Flamingo.png" />
    <img src="./../assets/illustrations/Forest.png" />
    <img src="./../assets/illustrations/Heart.png" />
    <img src="./../assets/illustrations/Forest.png" />
  </div>
</template>

<script lang="ts">
  export default {
    name: 'SideLeft'
  }
</script>
<style type="text/css" scoped>
  
.no-small img:nth-child(4n) {
  filter: hue-rotate(120deg);
}


.no-small img:nth-child(2n) {
  transform: scaleX(-1);
}
.no-small img {
  width:30px
}
.no-small img:nth-child(3n) {
  width:70px;
  margin-top:-5px;
  margin-bottom:-5px;
}
.no-small img:nth-child(5n) {
  width:20px;
}

</style>